module.exports = __webpack_public_path__ + "img/doorLogo1.cac72b3b.png";